import React, { useMemo } from 'react';

import { Language } from '@vestahealthcare/common/enums';
import { translate } from '@vestahealthcare/common/i18n';
import { EMPTY } from '@vestahealthcare/common/utils/constants';

type Props = {
  languages?: Language[];
  preferred?: Language;
};

export const MemberLanguagesDetail = ({ languages, preferred }: Props) => {
  const items = useMemo(
    () =>
      languages
        ?.map((l) => ({
          language: l,
          preferred: l === preferred,
        }))
        .sort(({ preferred: a }, { preferred: b }) => {
          if (a) return -1;
          if (b) return 1;
          return 0;
        }) || [],
    [languages, preferred],
  );
  return languages?.length ? (
    <>
      {items.map((l) => (
        <p className="no-margin" key={`member-language-${l.language?.value}`}>
          {l.language?.toString()}{' '}
          {l.preferred ? `(${translate('global.preferred')})` : ''}
        </p>
      ))}
    </>
  ) : (
    <span>{EMPTY}</span>
  );
};
